module.exports = __webpack_public_path__ + "img/FailureTurtle2.66a003d6.gif";